import { render, staticRenderFns } from "./Panne.vue?vue&type=template&id=672da1dc&scoped=true&"
import script from "./Panne.vue?vue&type=script&lang=js&"
export * from "./Panne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672da1dc",
  null
  
)

export default component.exports